import { createAction } from 'redux-actions';
export var SET_COMMENTS_OPEN = 'CLIENT.COMMENTS.SET_OPEN';
export var SET_HAS_NEW_COMMENTS = 'CLIENT.COMMENTS.SET_HAS_NEW';
export var SET_OPEN_ON_LOAD = 'CLIENT.COMMENTS.SET_OPEN_ON_LOAD';
export var setCommentsOpen = createAction(SET_COMMENTS_OPEN);
export var setHasNewComments = createAction(SET_HAS_NEW_COMMENTS);
export var setOpenCommentsOnLoad = createAction(SET_OPEN_ON_LOAD);
